// two bobby: tapping a variant dot on a product card shows that variant's photo and points the card's
// links at the variant. Falls back to following the link when there is nothing to swap.
document.addEventListener('click', (event) => {
  const dot = event.target.closest('.tb-dots__dot');
  if (!dot || !dot.dataset.tbSrc) return;
  const card = dot.closest('product-card, .product-grid__item, .resource-list__item');
  const img = card && card.querySelector('.card-gallery img, .product-media__image');
  if (!card || !img) return;

  event.preventDefault();
  img.removeAttribute('srcset');
  img.src = dot.dataset.tbSrc;
  card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
    if (!a.classList.contains('tb-dots__dot') && !a.closest('.tb-dots__more')) a.href = dot.dataset.tbVariantUrl;
  });
  const list = dot.closest('.tb-dots');
  list.querySelectorAll('[aria-current]').forEach((d) => d.removeAttribute('aria-current'));
  dot.setAttribute('aria-current', 'true');
});
